const pagesStarlinksEn = {
  alerts: {
    alertDescriptions: {
      accountDisabled: 'The Starlink device will be disabled if the account it is on is also disabled. Please log in to this account to get more information on the restriction.',
      actuatorMotorStuck: 'For actuated Starlink devices, the actuator motor is jammed and is not able to align the Starlink antenna to the desired angle. This can cause reduced performance, or the Starlink may not be able to connect to the network if the tilt too far from nominal.',
      blockedCountry: 'The Starlink device has moved to a country where Starlink is either not enabled or the service plan is limited to a specific region. If Starlink is coverage is enabled, upgrade to a Mobile Global or Mobile Priority Service plan. Or opt-in for Mobile Priority Data.',
      cellIsDisabled: 'The Starlink device has moved to a cell that Starlink does not serve. The current cell will not get beams for service.',
      dataOverageRateLimited: 'Starlink is rate limited as it is out of priority data. Add more by topping up or enabling automatic top-up.',
      dataUsageExceededQuota: 'The Starlink device has been disabled as data usage has execeeded the data quota. If Starlink coverage is enabled, upgrade your plan to a higher quota.',
      ethernetSlow100mbps: 'The ethernet link has auto negotiated to 100 Mbps. The Starlink device should auto negotiate to 1000 Mbps. There may be a cable or connection issue. Make sure the client device port is configured to 1000 Mbps auto-negotiation.',
      ethernetSlow10mbps: 'The ethernet link has auto negotiated to 10 Mbps. The Starlink device should auto negotiate to 1000 Mbps. There may be a cable or connection issue. Make sure the client device port is configured to 1000 Mbps auto-negotiation.',
      highSkyObstruction: 'The Starlink device fires this alerts when its obstruction map is more than 0.5% obstructed.',
      highTimeObstruction: 'The Starlink device detected a high percentage of the time when the Starlink device was not able to make a connection to a satellite. The high time obstruction alert is an indicator of the time that Starlink was unable to successfully make a connection and the connection was dropped. This alert will be set if 0.27% of the time Starlink field of view is obstructed. Check that the Starlink is in an unobstructed location in all directions.',
      invalidCountry: 'The Starlink device has moved to a country where Starlink is either not enabled or the service plan is limited to a specific region. If Starlink coverage is enabled, opt-in for Mobile Priority Data or upgrade to a Mobile Global or Mobile Priority Service plan.',
      mastNotVertical: 'For actuated Starlink devices, the Starlink alignment system is not able to align the Starlink antenna to the desired angle because the mast is greater than 30 degrees from vertical. This may cause poor performance, or the Starlink device may not be able to connect to the network unless corrected.',
      movingTooFast: 'The Starlink device is moving faster than the configured policy allows and service has been disabled. Update the service plan to one which supports higher speeds.',
      movingWhileNotMobile: 'The Starlink device is moving at greater than 10 MPH (4.4. meters per second) and service has been disabled. Update the service plan to a Mobile Priority service plan. Or opt-in for Mobile Priority Data.',
      noActiveServiceLine: 'The service line associated with the Starlink device is not active or has been cancelled. Check that the service line is active and the account is in good standing. Ensure that payment details are setup and no outstanding unpaid invoices have caused the service to be disabled.',
      noServiceInOcean: 'The Starlink device has moved into ocean coverage and does not have mobile priority data available. Update service plans to a Mobile Priority plan with additional data, or opt-in for Mobile Priority Data if you are on a mobile plan and have exceeded the Mobile Priority Data limit.',
      pendingSoftwareUpdateReboot: 'The Starlink device has downloaded a software update and is scheduled to reboot at 3 AM local time +/- 30 minutes. Local time is based on the current physical location of the Starlink hardware. After this alert is triggered, a manual reboot will also update the software if a the scheduled time is inconvenient.',
      popChange: 'The Starlink point of presence (PoP) has changed and as a result the Starlink will have a new IP address assigned for that region.',
      powerDisconnectDetected: 'The Starlink will report this alert when recovering from an unexpectedly power disconnect.',
      roamRestricted: "The Starlink device is being georestricted after roaming for too long in a country that is not the roaming terminal's home country. Restriction is not imposed if the user is in their home country.",
      thermalShutdown: 'The Starlink device has reached the maximum temperature threshold and has stopped service to cool down. Service will resume when the Starlink device reaches a nominal operating temperature. Starlink devices are designed to operation nominally when the ambient temperature is below 50 degrees Celcius. In extreme cases the Starlink will reboot in order to recover. Physically check that the Starlink device is installed in a location that is properly ventilated and not exposed to external heat sources, e.g. near an exhaust vent.',
      thermalThrottling: 'The Starlink device has reached a high temperature threshold and is throttling performance to cool down. Performance will improve when the Starlink device reaches a nominal operating temperature. Starlink devices are designed to operation nominally when the ambient temperature is below 50 degrees Celcius. Physically check that the Starlink device is installed in a location that is properly ventilated and not exposed to external heat sources e.g. near an exhaust vent.',
      thermalThrottlingPowerSupply: "The power supply is exceeding it's upper safety thermal threshold. As a result, the Starlink is throttling itself to reduce its power draw and let the power brick cool down.",
      tooFarFromServiceAddress: 'The Starlink device has moved too far from the service location on the account. Update the service address to resume service.',
      unableToAlign: "The Starlink device is installed in a location that it's not able to align the antenna to the desired angle. This may cause poor performance, or the Starlink device may not be able to connect to the network unless corrected. If the Starlink device has an actuator motor, physically inspect the Starlink install to ensure that the motor is functioning correctly by stowing and un-stowing the Starlink from the Starlink mobile app. If the Starlink device is a Flat mount un-actuated model, check that the Starlink is securely attached to a horizontal surface.",
      unknownLocation: 'The Starlink device cannot determine its location and cannot receive service.',
      unlicensedCountry: "The Starlink device is in an unlicensed country and has been disabled. The Starlink's policy prohibits being served in unlicensed countries.",
      unsupportedVersion: "The Starlink's software version is unsupported. This can happen if the Starlink has been offline for a while. Please submit a ticket if the issue persists."
    },
    alertTitles: {
      accountDisabled: 'Account disabled',
      actuatorMotorStuck: 'Actuator motor stuck',
      blockedCountry: 'Blocked country',
      cellIsDisabled: 'Cell is disabled',
      dataOverageRateLimited: 'Data overage rate limited',
      dataUsageExceededQuota: 'Data usage exceeded quota',
      ethernetSlow100mbps: 'Ethernet (100mbps)',
      ethernetSlow10mbps: 'Ethernet slow (10mbps)',
      highSkyObstruction: 'High sky obstruction',
      highTimeObstruction: 'High time obstruction',
      invalidCountry: 'Invalid country',
      mastNotVertical: 'Mast not vertical',
      movingTooFast: 'Moving too fast',
      movingWhileNotMobile: 'Moving while not mobile',
      noActiveServiceLine: 'No active service line',
      noServiceInOcean: 'No service in ocean',
      pendingSoftwareUpdateReboot: 'Pending software update reboot',
      popChange: 'PoP change',
      powerDisconnectDetected: 'Power disconnect detected',
      roamRestricted: 'Roam restricted',
      thermalShutdown: 'Thermal shutdown',
      thermalThrottling: 'Thermal throttling',
      thermalThrottlingPowerSupply: 'Thermal throttling of power supply',
      tooFarFromServiceAddress: 'Too far from service address',
      unableToAlign: 'Unable to align',
      unknownLocation: 'Unknown location',
      unlicensedCountry: 'Unlicensed country',
      unsupportedVersion: 'Unsupported version'
    },
    alertTypes: {
      'Data overage': 'Data overage',
      Disabled: 'Disabled',
      Others: 'Others',
      'Performance issue': 'Performance issue',
      'Router issue': 'Starlink Router issue',
      Update: 'Update'
    },
    filterPlaceholder: 'Filter by name...',
    pageTitle: 'Alerts',
    tabs: {
      ALL: 'All',
      DATA_OVERAGE: 'Data overage',
      DISABLED: 'Disabled',
      OTHERS: 'Others',
      PERFORMANCE_ISSUE: 'Performance issue',
      ROUTER_ISSUE: 'Starlink Router issue',
      UPDATE: 'Update'
    }
  },
  detail: {
    breadcrumbs: {
      starlinks: 'Starlink',
      terminal: 'Terminal'
    },
    dialogs: {
      addNetwork: {
        actions: {
          cancel: 'Cancel',
          save: 'Save'
        },
        fields: {
          network: {
            error: 'An error occurred',
            label: 'Network',
            placeholder: 'Select something...',
            searchPlaceholder: 'Search',
            selectPlaceholder: 'Select'
          }
        },
        title: 'Add network'
      },
      changeCustomer: {
        actions: {
          cancel: 'Cancel',
          save: 'Save'
        },
        fields: {
          from: 'From',
          to: 'To'
        },
        title: 'Change customer'
      },
      changePlacement: {
        actions: {
          cancel: 'Cancel',
          save: 'Save'
        },
        fields: {
          from: 'From',
          to: 'To'
        },
        title: 'Change placement'
      }
    },
    lastUpdated: 'Last updated',
    navigation: {
      networks: 'Networks',
      placement: 'Placement',
      routers: 'Starlink Routers',
      terminalId: 'Terminal id',
      userTerminalIdInfo: 'User terminal ID Info'
    },
    overview: {
      chartCard: {
        average: 'Avg.',
        chartVisualization: 'Chart visualization',
        vsYesterday: 'vs yesterday'
      },
      helpMessages: {
        downlink: 'Download speed in Mbps',
        latency: 'Round trip time to the Starlink POP',
        obstruction: 'Check to see where you may have obstructions causing intermittent service. Any obstruction level is bad for performance. If you see obstruction percentage greater than 0.2%, your install location or current surroundings is having a negative effect on performance. Anything more than 0.27% obstruction will cause enough outages for the end user to notice. In this case, please consider adjusting your install location or raising up your Starlinks to improve your performance. A Starlink should have a clear view above 20 degrees elevation, in ALL directions 360 degrees around the azimuth.',
        pingLoss: 'Percentage of "pings" sent that did not get a response from the POP. You should not experience any effects while ping loss is less than 3%',
        signalQuality: 'Signal Quality is an indication of Signal to Noise Ratio (SNR) which we represent as a percentage from 0% - 100%',
        uplink: 'Upload speed in Mbps'
      },
      metrics: {
        downlinkThroughput: 'Downlink throughput',
        latency: 'Latency',
        obstruction: 'Obstruction',
        pingLatency: 'Ping latency',
        signalQuality: 'Signal quality',
        uplinkThroughput: 'Uplink throughput'
      },
      noData: 'No data available',
      sections: {
        currentPerformance: 'Current Performance',
        networkStatistics: 'Network statistics'
      },
      timeRanges: {
        '1hr': '1 hr',
        '3hrs': '3 hrs',
        '7days': '7 days',
        '24hrs': '24 hrs',
        '30days': '30 days'
      }
    },
    sections: {
      customer: {
        businessPartnerCode: 'BP Code',
        businessPartnerName: 'BP Name',
        changeCustomer: 'Change customer',
        notSet: 'Not set',
        title: 'Customer'
      },
      networks: {
        addNetwork: 'Add network',
        noData: 'No networks registered',
        removeNetwork: 'Remove network',
        tableHeaders: {
          ipAddress: 'IP Address',
          network: 'Network',
          purpose: 'Purpose'
        },
        title: 'Networks'
      },
      placement: {
        address: 'Address',
        changePlacement: 'Change placement',
        currentGeolocation: 'Current geolocation',
        mapPlaceholder: 'Location information could not be retrieved',
        placement: 'Placement',
        title: 'Placement'
      },
      routers: {
        addRouter: 'Add Starlink router',
        noData: 'No Starlink routers found',
        tableHeaders: {
          router: 'Starlink Router',
          starlinkRouterId: 'Starlink Router ID',
          wifiSoftwareVersion: 'Wi-Fi software version'
        },
        title: 'Starlink Routers'
      },
      userTerminalIdInfo: {
        dishSerialNumber: 'Dish serial number',
        kitSerialNumber: 'Kit serial number',
        name: 'Name',
        nickname: 'Nickname',
        title: 'User Terminal ID Info',
        userTerminalId: 'User terminal ID'
      }
    },
    tabs: {
      detail: 'Detail',
      networks: 'Networks',
      overview: 'Overview',
      rulesAndPolicy: 'Rules & Policy'
    },
    toast: {
      saveSuccess: 'Saved successfully'
    }
  },
  list: {
    filterPlaceholder: 'Filter by name...',
    filters: {},
    pageTitle: 'Starlink',
    tabs: {
      ACTIVE: 'Active',
      ALL: 'All',
      NOT_ACTIVE: 'Inactive',
      alerts: 'Alerts',
      billingAndCost: 'Billing & Cost',
      marketplace: 'Marketplace',
      operationActivity: 'Operation Activity',
      overview: 'Overview',
      userTerminals: 'User Terminals'
    }
  },
  overview: {
    dataPool: {
      dailyAverage: 'Daily average',
      estimatedOn: 'Estimated on',
      monthlyDataCap: 'Monthly data cap',
      title: 'Data pool'
    },
    geolocation: {
      status: {
        alert: 'Alert',
        healthy: 'Healthy',
        notDetected: 'Not detected'
      },
      title: 'Geolocation',
      total: 'Total'
    },
    monthlyDataUsage: {
      avg: 'Avg.',
      title: 'Monthly Data Usage'
    },
    noData: 'No data available',
    placement: {
      fleet: 'Fleet',
      place: 'Place',
      title: 'Placement'
    }
  }
};
export default pagesStarlinksEn;